export const CDN_PATH = 'https://nova.file.video.qpic.cn'; // cdn域名

export const UPLOAD_PATH = 'uploadFile'; // cdn 前端上传路径

export const COS_REGION = 'ap-guangzhou'; // 存储桶所在地域

export const COS_BUCKET = 'nova-1258344701'; // 存储桶

export const DEFAULT_UUID = '000000000000000'; // 默认uuid
